import { motion } from "framer-motion";
import styled from "styled-components";
import bgImage from "../background.jpg";

export const MotionContainer = styled(motion.div)`
    font-size: 4vh;
    color: white;
    text-align: center;
    font-weight: 800;
    display: flex;
    align-items: center;
    padding: 1.2vh;
    justify-content: center;
    -webkit-text-stroke-width: .15vw;
    -webkit-text-stroke-color: black;
`

export const TopContainer = styled(motion.div)`
    position: sticky;
    top: 0;
    
    width: 100%;
    color: white;
    text-align: center;
    font-weight: 1000;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    -webkit-text-stroke-width: .2px;
    -webkit-text-stroke-color: black;
    z-index: 1;
`

export const CenteredContainers = styled.div`
    position: sticky;
    top: 0;
    padding-top: 35vh;
    height: 20vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`;
export const IntroScene = styled(motion.div)`
    width: 100%;
    diplay: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`
export const CorrectContainer = styled(motion.span)`
    font-size: 20vh;
    font-weight: 800;
`

export const Page = styled(motion.div)`
    font-family: Helvetica;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: top;
    background-color: black;
    width: 100%;
    overflow: clip;
        
`
export const BG = styled(motion.div)`
    position: fixed;
    top: 0;
    width: 100%;
    bottom: 0;
    background-image: url(${bgImage});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    pointerEvents: none;
    overflow: hidden;
`

export const CenteredLow = styled(motion.div)`
    display: flex;
    color: white;
    width: 100%;
    padding-top: 0vh;
    padding-bottom: 0vh;
    border-radius: 25px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
`
export const CenteredText = styled(motion.div)`
    height: 100%;
    align-item: center;
    justify-content: center;
`
export const Counter = styled(motion.div)`
    display: flex;
    flex-direction: column;
    height: 100vh;
    padding-top: 10vh;
    align-items: center;
    justify-content: center;
    font-size: 2vh;
    text-align: center;
`
export const TextBox = styled.div`
    text-align: left;
    padding-left: 5vw;
    padding-right: 5vw;
     display: flex;
    font-size: 2vh;
    color: white;
    background-color: #2c2a30bd;
    border-radius: 0px;
    border: .25rem solid #636363;
    border-left: none;
    border-right: none;
    width: 90vw;
    flex-direction: column;
    align-items: left;
    justify-content: top;
    z-index: 0;
`

export const CorrectButton = styled.button`
    border: 3px solid black;
    font-size: 2vh;
    width: 60vw;
    max-width: 500px;
    height: 10vh;
    background: white;
    color: black;
    &:hover {
    background: black; /* Styles to apply on hover */
    color: white;
    cursor: pointer;
    border-color: white;
  }
`

export const Disclaimer = styled.div`
    background-color: #0000009a;
    z-index: 1;
    color: white;
    padding: 1vh;
    text-align: center;
    justify-content: center;
    align-items: center;
`